<template>
  <div>
    <div class="container mini">
      <AccountWidget />
      <div class="bg-gray rounded-md shadow mt-2 mb-12 py-1">
        <div class="text-center border-b border-purple-gray">
          <h2
            class="mt-5 text-base sm:text-2xl font-semibold uppercase text-primary"
          >
            {{ $t("start.title") }}
          </h2>
          <h3 class="text-sm sm:text-base text-black-display mt-1 mb-6">
            {{ $t("start.choose") }}
          </h3>
        </div>
        <div class="start-menu">
          <button
            class="start-menu__item config-btn"
            @click="initNewOrder"
          >
            <img src="/img/dashboard/order.jpg">
            <div class="block mt-4 w-48">
              <span>{{ $t("start.newOrder") }}</span>
              <div class="absolute hidden lg:inline w-5 h-5 pl-3">
                <div class="tooltip">
                  <InfoIcon class="inline" />
                  <div class="tooltip__content">
                    {{ $t("start.newOrderTooltip") }}
                  </div>
                </div>
              </div>
            </div>
          </button>
          <button
            class="start-menu__item config-btn"
            @click="initNewCustomOrder"
          >
            <img src="/img/dashboard/order-nonstandard.jpg">
            <div class="block mt-4 w-48">
              <span>{{ $t("start.customOrder") }}</span>
              <div class="absolute hidden lg:inline w-5 h-5 pl-3">
                <div class="tooltip">
                  <InfoIcon class="inline" />
                  <div class="tooltip__content">
                    {{ $t("start.customOrderTooltip") }}
                  </div>
                </div>
              </div>
            </div>
          </button>
          <button
            class="start-menu__item config-btn"
            @click="initActions"
          >
            <img src="/img/dashboard/actions.jpg">
            <div class="block mt-4 w-48">
              <span>{{ $t('action.title') }}</span>
              <div class="absolute hidden lg:inline w-5 h-5 pl-3">
                <div class="tooltip">
                  <InfoIcon class="inline" />
                  <div class="tooltip__content">
                    {{ $t("action.tooltip") }}
                  </div>
                </div>
              </div>
            </div>
          </button>
          <button
            class="start-menu__item config-btn"
            @click="initTeam"
          >
            <img src="/img/dashboard/team.jpg">
            <div class="block mt-4 w-48">
              <span>{{ $t('team.title') }}</span>
              <div class="absolute hidden lg:inline w-5 h-5 pl-3">
                <div class="tooltip">
                  <InfoIcon class="inline" />
                  <div class="tooltip__content">
                    {{ $t("team.tooltip") }}
                  </div>
                </div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import InfoIcon from '@/assets/icons/info.svg';
import AccountWidget from '@/components/AccountWidget';
import { ORDER, CUSTOM_SUMMARY } from '@/router/routes.names';

export default {
  name: 'Start',
  components: {
    AccountWidget,
    InfoIcon,
  },
  methods: {
    ...mapActions('order', ['resetOrder']),
    async initNewOrder() {
      await this.resetOrder();
      this.$router.push({ name: ORDER });
    },
    async initNewCustomOrder() {
      await this.resetOrder();
      this.$router.push({ name: CUSTOM_SUMMARY });
    },
    async initActions() {
      this.$router.push({ name: 'ACTIONS' });
    },
    async initTeam() {
      this.$router.push({ name: 'TEAMS' });
    },
  },
};
</script>
<style lang="scss" scoped>
.start-menu {
  @apply w-full pt-12 pb-16 px-6;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  column-gap: 20px;
  @screen md {
    @apply pb-32;
    grid-template-columns: repeat(2, 1fr);
  }
  &__item {
    @apply mb-6;

    img {
      height: 150px;
    }
  }
}

</style>
